export default __webpack_public_path__ + "static/media/forestly-noexpl-intro_DE.8af4361d.png";